import { render } from "./LmsModuleView.vue?vue&type=template&id=17db7ba6&scoped=true&ts=true"
import script from "./LmsModuleView.vue?vue&type=script&lang=ts"
export * from "./LmsModuleView.vue?vue&type=script&lang=ts"

import "./LmsModuleView.vue?vue&type=style&index=0&id=17db7ba6&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/webapp/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17db7ba6"]])

export default __exports__